import { NotificationMessageOptionModel } from "./NotificationMessageOptionModel";

export class NotificationMessageForDisplayModel {
  id!: string;
  merchantId!: number;
  userId!: number;
  notificationTypeId!: number;
  messageTypeId!: number;
  notificationDateTime!: Date;
  option!: NotificationMessageOptionModel;
  isSeen!: boolean;
  icon!: NotificationMessageIconForDisplay;
  message!: NotificationMessageForDisplay;
  notificationUrlImage!: string;
  notificationUserName!: string;
  notificationUserId!: number;
}

export class NotificationMessageIconForDisplay {
  name!: string;
  color!: string;
}

export class NotificationMessageForDisplay {
  headerMessage!: string;
  descriptionMessage!: string;
}
